<template>
    <div class="home">
        <!-- 头部导航栏 -->
        <iristar-header></iristar-header>
        <div class="h50px"></div>
        <transition name="el-fade-in-linear">
            <router-view />
        </transition>
        <!-- 网站底部 -->
        <iristar-foot></iristar-foot>
    </div>
</template>

<script>
import IristarHeader from "@/components/IristarHeader";
import IristarFoot from "@/components/IristarFoot";

export default {
    name: "Home",
    watch: {
        $route() {
            document.getElementsByTagName("html")[0].scrollTop = 0;
        },
    },
    components: {
        IristarHeader,
        IristarFoot,
    },
};
</script>

<style lang="less">
</style>
